export class AttrezzaturaDTO {
  categoriaAttrezzaturaId: number;
  categoriaAttrezzaturaIdParent: number;
}
